'use client'

import { useKeenSlider } from 'keen-slider/react'
import 'keen-slider/keen-slider.min.css'
import Image from 'next/image'
import Link from 'next/link'
import { useEffect, useRef } from 'react'
import './companybanner.css'
import { CompanySlider } from '@/services/dataTypes'
import { getBaseImageUrl } from '@/constants/hooks'
import { faAngleLeft, faAngleRight, faArrowRight, FontAwesomeIcon } from '@/constants/icons'
import link from 'next/link'
// import Image from "@/components/shared/Image";

interface Props {
    sliders: CompanySlider[]
    domain: string
}

const ClientSlider = ({ sliders, domain }: Props) => {
    const [sliderRef, slider] = useKeenSlider<HTMLDivElement>({
        loop: true,
        slides: {
            perView: 1,
        },
    })

    const timeoutRef = useRef<NodeJS.Timeout | null>(null)

    useEffect(() => {
        if (!slider.current || sliders.length <= 1) return

        const startAutoSlide = () => {
            timeoutRef.current = setInterval(() => {
                slider.current?.next()
            }, 5000)
        }

        const stopAutoSlide = () => {
            if (timeoutRef.current) clearInterval(timeoutRef.current)
        }

        startAutoSlide()
        return () => stopAutoSlide()
    }, [slider, sliders.length])

    const BannerImage = ({ src, alt, priority = false, link = '#' }: { src: string; alt: string; priority?: boolean; link?: string }) => (
        <div style={{ position: 'relative', width: '100%', height: '100%' }}>
            <Link href={link} className="slider-link-shared" aria-label={`View ${alt}`} title={`View ${alt}`}>
                <Image
                    src={getBaseImageUrl(domain, src, "")}
                    height={500}
                    width={1400}
                    sizes="(max-width: 768px) 100vw, 1400px"
                    alt={alt}
                    className="slider-img-shared"
                    priority={priority}
                    fetchPriority={priority ? "high" : "auto"}
                    loading={priority ? "eager" : "lazy"}
                />
            </Link>
        </div>
    )

    if (sliders?.length <= 1) {
        const slide = sliders[0]
        return (
            <div className="keen-slider-wrapper" style={{ position: 'relative' }}>
                {slide && (
                    <BannerImage
                        src={slide.slider_image}
                        alt={'Slider Image 1'}
                        priority
                        link={slide?.button_link || '#'}
                    />
                )}
            </div>
        )
    }

    return (
        <div
            className="keen-slider-wrapper"
            style={{ position: 'relative' }}
            onMouseEnter={() => timeoutRef.current && clearInterval(timeoutRef.current)}
            onMouseLeave={() => {
                timeoutRef.current = setInterval(() => {
                    slider.current?.next()
                }, 4000)
            }}
        >
            <div ref={sliderRef} className="keen-slider">
                {sliders.map((slide, i) => (
                    <div className="keen-slider__slide slider-container-shared" key={i}>
                        <BannerImage
                            src={slide?.slider_image}
                            alt={'Slider Image ' + (i + 1)}
                            priority={i === 0}
                            link={slide?.button_link || '#'}
                        />
                        {slide?.text || (slide?.button_text && slide?.button_link) && (
                            <div className="slider-overlay-shared">
                                {slide?.text && (
                                    <h1 className="slider-title-shared">{slide?.text}</h1>
                                )}
                                {slide?.button_text && slide?.button_link && (
                                    <div className="slider-btn-shared">
                                        <Link
                                            href={slide?.button_link}
                                            className="btn btn-primary wd-shop-btn slider-btn-shared banner-slider-btn"
                                        >
                                            {slide?.button_text}
                                            <FontAwesomeIcon icon={faArrowRight} style={{ width: '16px', height: '16px', color: 'white' }} />
                                        </Link>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                ))}
            </div>

            {/* Arrows */}
            <div
                className="custom-slider-prev-shared"
                onClick={() => slider.current?.prev()}
            >
                <button className="custom-arrow-button">
                    <FontAwesomeIcon icon={faAngleLeft} style={{ width: '16px', height: '16px', color: 'white' }} />
                </button>
            </div>

            <div
                className="custom-slider-next-shared"
                onClick={() => slider.current?.next()}
            >
                <button className="custom-arrow-button">
                    <FontAwesomeIcon icon={faAngleRight} style={{ width: '16px', height: '16px', color: 'white' }} />
                </button>
            </div>
        </div>
    )
}

export default ClientSlider
